import { useEffect, useState } from 'react'

/**
 * Whether the browser is in fullscreen, and a toggle for it.
 *
 * The flag comes from the `fullscreenchange` event rather than from the toggle, so pressing F11 or
 * Escape keeps it honest. `onBlocked` fires when the browser refuses the request — it only grants
 * fullscreen from a user gesture, and some kiosk policies deny it outright.
 */
export const useFullscreen = (onBlocked) => {
  const [isFullscreen, setIsFullscreen] = useState(false)

  useEffect(() => {
    const onChange = () => setIsFullscreen(Boolean(document.fullscreenElement))

    document.addEventListener('fullscreenchange', onChange)

    return () => document.removeEventListener('fullscreenchange', onChange)
  }, [])

  const toggle = () => {
    const request = document.fullscreenElement
      ? document.exitFullscreen()
      : document.documentElement.requestFullscreen()

    request?.catch(() => onBlocked?.())
  }

  return { isFullscreen, toggle }
}
